import React, { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Services } from '@/services/services';
import { CurrentSession } from '@/services/repository/session';
import { CleanWizardData } from './Model';

export const StartMachineFilesWizard = ({ services }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()
  const machineId = useParams().machineid

  useEffect(() => {
    if (machineId) {
      CleanWizardData(machineId)
      navigate(`/communal/machine/${machineId}/files/upload/page1`, { replace: true })
    } else {
      navigate(`/`, { replace: true })
    }
  }, [machineId, navigate]);

  return null; // No UI needed since it redirects immediately
}
